import { NOTE_TRIGGER_ATTRIBUTE, noteAnchorOf } from '@/components/matrix/note-marker';
import { cn } from '@/lib/utils';
import { Icon } from '@pms-digital/design-system';

export interface NoteAddButtonProps {
  /** The spot, as the accessible name words it: « Palier Barre des minimas ». */
  targetLabel: string;
  /** Receives the cell or header the button sits in. */
  onAdd: (anchor: HTMLElement) => void;
  className?: string;
}

/**
 * The « + » bubble that stands in for the marker on a spot with no open note
 * (planche 11): invisible until the cell or header is hovered or the button
 * focused, never `display: none` so the keyboard still reaches it.
 */
export function NoteAddButton({ targetLabel, onAdd, className }: NoteAddButtonProps) {
  return (
    <button
      type="button"
      {...{ [NOTE_TRIGGER_ATTRIBUTE]: '' }}
      aria-label={`Ajouter une note sur ${targetLabel}`}
      title="Ajouter une note"
      onClick={(event) => {
        event.stopPropagation();
        onAdd(noteAnchorOf(event.currentTarget));
      }}
      onKeyDown={(event) => event.stopPropagation()}
      className={cn(
        'inline-flex shrink-0 items-center rounded p-0 text-bleu-nuit opacity-0 transition-opacity hover:bg-bleu-nuit-tint focus-visible:opacity-100 focus-visible:outline-2 focus-visible:outline-bleu-nuit group-hover:opacity-100',
        className,
      )}
    >
      <Icon name="add_comment" size={14} />
    </button>
  );
}
